module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper-slide', {
    staticClass: "lightbox-gallery-slide"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c54c4d34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/lightbox/gallery-slide.vue
// module id = 2127
// module chunks = 2